import { Tooltip } from "@material-ui/core";
import { limitString, capitalizeFirstLetter } from "../../../utils/string";
import { activityTypeToName } from "../../../utils/teacher_portal/activityTypeToString";
import Icon from "../../general/Icon";
import BoldTableCell from "../general/table/BoldTableCell";

const TeacherPortalLatestActivities = (params) => {
    const { userEvents, loadMoreUserEvents } = params;
    const handleLoadMore = () => {
        loadMoreUserEvents();
    };

    console.log("userEvents", userEvents);

    return (
        <>
            <div className="w-full overflow-x-auto">
                <table className="w-full border-collapse text-left">
                    <thead>
                        <tr className="border-b border-card_dark">
                            <BoldTableCell>Activity Type</BoldTableCell>
                            <BoldTableCell>Activity Name</BoldTableCell>
                            <BoldTableCell>Username</BoldTableCell>
                            <BoldTableCell>Action</BoldTableCell>
                            <BoldTableCell>Time</BoldTableCell>
                        </tr>
                    </thead>
                    <tbody>
                        {userEvents && userEvents.map((userEvent, index) => (
                            <tr key={userEvent.id || `${userEvent.activityid}-${userEvent.timestamp}-${index}`} className="border-b border-card_dark last:border-0">
                                <td className="px-4 py-2">
                                    <Tooltip title={activityTypeToName(userEvent.activitytype)}>
                                        
                                        <span className="inline-flex"><Icon type={userEvent.activitytype} color="black" /></span>
                                    </Tooltip>
                                </td>
                                <td className="px-4 py-2">
                                    <Tooltip title={userEvent.activitytitle}>
                                        <span>{limitString(userEvent.activitytitle ?? "", 40)}</span>
                                    </Tooltip>
                                </td>
                                <td className="px-4 py-2">
                                    <Tooltip title={"Username: " + userEvent.username}>
                                        <span>{userEvent.firstname + " " + userEvent.lastname}</span>
                                    </Tooltip>
                                </td>
                                <td className="px-4 py-2">{capitalizeFirstLetter(userEvent.verb)}</td>
                                <td className="px-4 py-2">{userEvent.timestamp}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="mt-2.5">
                <button type="button" className="rounded px-3 py-2 text-link hover:bg-card" onClick={handleLoadMore}>Load more...</button>
            </div>
        </>
    );
};

export default TeacherPortalLatestActivities;